import { memo } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SwitchChipGroup } from '@frontend/design-system';
import { NetworkType } from '../../types/insurance-report-api.types';

type NetworkFilterProps = {
  networkNames: string[];
  filterValue: NetworkType | string;
  handleFilterChange: (value: string) => void;
};
export const NetworkFilter = memo(({ networkNames, filterValue, handleFilterChange }: NetworkFilterProps) => {
  return (
    <>
      <SwitchChipGroup
        id={'global'}
        css={switchChip}
        value={[filterValue]}
        setValue={(value) => {
          if (Array.isArray(value)) {
            handleFilterChange(value[0]);
          }
        }}
        singleSelect
      >
        {networkNames.map((name) => {
          return (
            <SwitchChipGroup.Option key={name} value={name} className={filterValue === name ? 'selected' : ''}>
              {name}
            </SwitchChipGroup.Option>
          );
        })}
      </SwitchChipGroup>
    </>
  );
});

const switchChip = css`
  gap: ${theme.spacing(2)};
  margin: ${theme.spacing(0.5)};
  span {
    color: ${theme.colors.neutral90};
  }
  .selected,
  .selected:hover {
    background: ${theme.colors.primary5};
    border: solid 1px ${theme.colors.primary50};
  }
  .chip {
    :focus {
      outline: none;
    }
  }
`;
